export default "__VITE_ASSET___FnxO42r__"